/* eslint-disable no-restricted-imports */
import {
    DirectPayForType,
    DirectSpendLimitType,
    DirectStrategyType,
} from '../../../../data-layer/direct/types';
import { DropdownOption } from '../../../../ui/business/ContentPromotionBudget/parts/ContentPromotionDropdown/types';

export const getSpendLimitOptions = (
    strategyType: DirectStrategyType,
    payFor: DirectPayForType,
): DropdownOption[] => {
    if (strategyType === DirectStrategyType.MAX_CONVERSIONS && payFor === DirectPayForType.CLICKS) {
        return [
            // https://st.yandex-team.ru/INSPIRE-7417
            // { value: DirectSpendLimitType.WEEKLY_LIMIT, label: 'Бюджет' },
            // { value: DirectSpendLimitType.CRR, label: 'Доля рекламных расходов' },
            { value: DirectSpendLimitType.AVERAGE_CPA, label: 'Средняя цена конверсии' },
        ];
    }

    if (
        strategyType === DirectStrategyType.MAX_CONVERSIONS &&
        payFor === DirectPayForType.CONVERSIONS
    ) {
        return [
            { value: DirectSpendLimitType.CONVERSION_COST, label: 'Цена конверсии' },
            // https://st.yandex-team.ru/INSPIRE-7417
            // { value: DirectSpendLimitType.CRR, label: 'Доля рекламных расходов' },
        ];
    }

    if (strategyType === DirectStrategyType.MAX_CLICKS) {
        return [
            // https://st.yandex-team.ru/INSPIRE-7417
            // { value: DirectSpendLimitType.WEEKLY_LIMIT, label: 'Бюджет' },
            { value: DirectSpendLimitType.AVERAGE_CPC, label: 'Средняя цена клика' },
        ];
    }

    return [];
};
